export const HIDDEN_FIELDS = new Set([
    'robots_txt_status_code',
    'design_semantic'
]);

export const LONG_TEXT_FIELDS = ['technology_stack', 'performance_findings'];

export const DNS_FIELDS = new Set([
    'dns_apex_domain',
    'dns_nameservers',
    'dns_ip_addresses',
    'dns_errors',
    'dns_hosting_provider',
    'dns_hosting_confidence'
]);

export const SEO_FIELDS = new Set([
    'seo_key_findings',
    'robots_txt_sitemaps',
    'canonical_url',
    'meta_description_length',
    'title_length',
    'structured_data_types'
]);

export const SITE_TYPE_FIELDS = new Set([
    'site_sub_type',
    'site_type',
    'site_type_confidence',
    'site_type_notes',
    'site_type_primary_call_to_action',
    'site_type_signals'
]);

export const CUSTOMER_FIT_FIELDS = new Set([
    'customer_fit_rating',
    'customer_fit_confidence',
    'customer_fit_signals',
    'customer_fit_recommended_motion'
]);

export const DONATION_FIELDS = new Set([
    'donation_page_urls',
    'donation_cta_labels',
    'donation_notes'
]);


